/**
 * Create function usable in Array.sort()
 * @example
 * ```ts
 * const candidates: any[] = [];
 * candidates.sort(createComparator(
 *   (x) => x.ambiguous,
 *   (_, y) => y.refCount, // DESC
 *   (x) => x.name.length,
 *   (x) => x.name,
 * ));
 * ```
 */
export function createComparator(...selectors) {
    return (a, b) => {
        for (const selector of selectors) {
            const valA = selector(a, b);
            if (valA === null)
                continue;
            const valB = selector(b, a);
            // eslint-disable-next-line
            if (valB === null || valA == valB)
                continue;
            if (valA > valB)
                return 1;
            if (valA < valB)
                return -1;
        }
        return 0;
    };
}
//# sourceMappingURL=createComparator.js.map